import { h } from 'preact'; /** @jsx h */
import { useEffect } from 'preact/hooks';

import simpleParallax from 'simple-parallax-js';

import './ParallaxBanner.scss';

const ParallaxBanner = ({
    children,
    imageSrc,
    alt,
    className = '',
    emergencyStripes = '',
    orientation = 'left',
    color = '',
    colorTop = '',
    colorBottom = ''
}) => {
    // useEffect for simpleParallax on full width images
    useEffect(() => {
        const coverImages = document.querySelectorAll('.parallax-image');
        const coverImageParallaxes = Array.from(coverImages).map(coverImage => {
            // eslint-disable-next-line new-cap
            return new simpleParallax(coverImage, {
                orientation: 'down',
                overflow: true
            });
        });

        return () => {
            coverImageParallaxes.forEach((coverImageParallax, index) => {
                if (coverImages[index]) {
                    coverImageParallax.destroy();
                }
            });
        };
    }, []);

    return (
        <div className={`parallax-banner ${className} color-${color}`}>
            <div
                className={`parallax-shape parallax-shape-top parallax-shape-top-${orientation} color-${colorTop}`}
            />
            <div className="parallax-image-wrapper">
                <img
                    className="parallax-image"
                    decoding="async"
                    loading="lazy"
                    src={imageSrc}
                    alt={alt}
                />
                {emergencyStripes !== '' && (
                    <div className={`emergency-stripes emergency-stripes-${orientation}`}>
                        <img
                            src={
                                emergencyStripes === 'red'
                                    ? 'https://norskluftambulanse.no/wp-content/uploads/2023/11/201112_Akuttstriper_RGB.svg'
                                    : 'https://norskluftambulanse.no/wp-content/uploads/2024/02/akuttstriper-vertikal-gul.svg'
                            }
                            alt="Akuttstriper"
                        />
                    </div>
                )}
                {children}
            </div>
            <div
                className={`parallax-shape parallax-shape-bottom parallax-shape-bottom-${orientation} color-${colorBottom}`}
            />
        </div>
    );
};

export default ParallaxBanner;
